import React, { useState } from 'react';

import utils from '../../../services/utils';
import ShowArrowButton from '../../Buttons/ShowArrowButton/ShowArrowButton';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Pagination from '../../Pagination/Pagination';

import classes from './ShowItems.module.scss';

const ShowItems = ({ className, items }) => {
  const contentClasses = [classes.content];
  className && contentClasses.push(className);

  const limit = 5;

  const [itemsState, setItemsState] = useState(items.map((item, idx) => ({ ...item, show: false, idx })));
  const [page, setPage] = useState(0);
  const [showItems, setShowItems] = useState(true);

  const pages = itemsState.length / limit;

  const showItemHandler = idx => {
    setItemsState(items => {
      const auxItems = [...items];
      auxItems[idx] = { ...auxItems[idx], show: !auxItems[idx].show };
      return auxItems;
    });
  };

  const showItemsHandler = () => {
    setShowItems(showItem => !showItem);
  };

  return (
    <div className={contentClasses.join(' ')}>
      <div className={classes.space}>
        <span className='bold-20'>Items de la cuenta de cobro ({itemsState.length}) </span>
        <ShowArrowButton showState={showItems} onClick={showItemsHandler} />
      </div>
      {showItems && (
        <div className={classes.cards}>
          {itemsState.slice(page * limit, limit * (page + 1)).map(item => (
            <div key={item.idx} className={classes.card}>
              <div className={classes.space}>
                <span className='semibold-18'>{item.description}</span>
                <ShowArrowButton showState={item.show} onClick={() => showItemHandler(item.idx)} />
              </div>
              {item.show && (
                <div className={classes.fields}>
                  {/* <FieldBold title='CUENTA CONTABLE RETEICA' value={'hola'} />
                  <FieldBold title='CUENTA CONTABLE RETEICA' value={'hola'} /> */}
                  <FieldBold title='SUBTOTAL DEL ITEM' value={utils.moneyFormat(item.lineExtensionAmount)} />
                  <FieldBold title='MONTO TOTAL DEL ITEM*' value={utils.moneyFormat(item.payableAmount)} />
                </div>
              )}
            </div>
          ))}
          <Pagination
            className={classes.pagination}
            pages={pages}
            current={page}
            showNext={page < pages - 1}
            onPrevious={() => setPage(page => page - 1)}
            onNext={() => setPage(page => page + 1)}
            onPage={page => setPage(page)}
            limit={limit}
            //onLimit={limitChangeHandler}
          />
        </div>
      )}
    </div>
  );
};

export default ShowItems;
